/**
 * @file    EngineRoutes.tsx
 * @scope   ENGINE
 * @summary Renders every registered plugin's sub-view routes.
 * @consumes ENGINE_PLUGINS
 * @produces EngineRoutes
 * @sideEffects None. Each plugin renders nothing when the current tab is not its own.
 */
import React from 'react';
import { ENGINE_PLUGINS } from './registry';
import { EngineRoutesProps } from './types';

const EngineRoutes: React.FC<EngineRoutesProps> = (props) => (
  <>
    {ENGINE_PLUGINS.map(({ id, Routes }) => (
      <Routes key={id} {...props} />
    ))}
  </>
);

export default EngineRoutes;
